import { Get_Error, Transfere_Leads_TO_Data_Center } from '../Types';

const intial = {
  tranceferetodatacenter: [],

  loading: true,
};

const CRMDataCenter_reducer = (state = intial, action) => {
  switch (action.type) {
    case Transfere_Leads_TO_Data_Center:
      return {
        ...state,
        tranceferetodatacenter: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        tranceferetodatacenter: action.payload,
      };
    default:
      return state;
  }
};

export default CRMDataCenter_reducer;
